import { c as _c } from "react/compiler-runtime";
import { HOMEPAGE_PATH } from '../../utils/constants/local-paths';
import { BackButton } from '../back-button/back-button';
export const BackToHomepageButton = t0 => {
  const $ = _c(2);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <BackButton dataTestId="back-to-dashboard-link" to={HOMEPAGE_PATH}>{label}</BackButton>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};